module.exports = __webpack_public_path__ + "static/media/feather.023ba082.svg";